export default __webpack_public_path__ + "static/media/2WheelCar.0bd83bc5.jpg";